import React, { useEffect } from 'react';
import './chatwoot.css';

const AUTO_DISMISS_MS = 15000;

function initials(name = '') {
  return name.split(' ').slice(0, 2).map(w => w[0] || '').join('').toUpperCase();
}

export default function ChatwootToast({ message, onDismiss, onOpen }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [message, onDismiss]);

  if (!message) return null;

  const preview = (message.preview || '').substring(0, 90);

  return (
    <div className="cw-toast" role="alert">
      <div className="cw-toast-header">
        <i className="bi bi-bell-fill cw-toast-bell" />
        <span className="cw-toast-label">Nova mensagem</span>
        <button className="cw-toast-x" onClick={onDismiss} aria-label="Fechar">
          <i className="bi bi-x-lg" />
        </button>
      </div>

      <div className="cw-toast-body">
        <div className="cw-toast-avatar">{initials(message.contact)}</div>
        <div className="cw-toast-content">
          <div className="cw-toast-name">{message.contact}</div>
          <div className="cw-toast-preview">
            {preview}{message.preview?.length > 90 ? '…' : ''}
          </div>
        </div>
      </div>

      <div className="cw-toast-footer">
        <button
          className="cw-toast-see"
          onClick={() => { onOpen(message.conversationId); onDismiss(); }}
        >
          <i className="bi bi-chat-dots-fill" style={{ marginRight: 6 }} />
          Ver conversa
        </button>
      </div>

      {/* barra de progresso — reinicia via key quando chega nova mensagem */}
      <div className="cw-toast-progress">
        <div className="cw-toast-bar" key={`${message.conversationId}-${message.preview}`} />
      </div>
    </div>
  );
}
